import { Component, OnInit } from '@angular/core';
import { Params, ActivatedRoute } from '@angular/router';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { ModalService } from 'src/app/shared/service/modal.service';
import { NeoComunService } from '../../comun/services/neoComun.service';
import { UserService } from '../../services/user.service';
import { MicroempresarioService } from '../services/microempresario.service';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

@Component({
    selector: 'app-aceptacion-solicitud-credito',
    templateUrl: './aceptacion-solicitud-credito.component.html',
    styleUrls: ['./aceptacion-solicitud-credito.component.scss'],
    providers: [NeoComunService],
    standalone: false
})
export class AceptacionSolicitudCreditoComponent implements OnInit {
  idSolicitud: string = '';
  aliadoFinanciero: string = '';
  urlLanding: string;
  user: any;
  mensajeLanding: string;
  constructor(
    private _route: ActivatedRoute,
    private _microempresarioService: MicroempresarioService,
    private _userService: UserService,
    private _parametrosService: BancoldexService,
    public _modal: ModalService,
    private _analyticsTag: AnalyticsTagService,
  ) {
    this.user = this._userService.getUser();
  }

  ngOnInit(): void {
    this.traerNumeroSolicitud();
  }

  traerNumeroSolicitud() {
    this._route.params.subscribe((params: Params) => {
      this.idSolicitud = params['id'];
      this.traerIF();
    });
  }

  traerIF() {
    this._microempresarioService
      .getIntermediarioAproboSolicitud(this.idSolicitud)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            var data = response['data'];
            this.aliadoFinanciero = data.nombreIntermediarioAproboSolicitud;
            this.urlLanding = data.landingAliado;
          }
        },
        (error) => { }
      );
  }

  trackFinalizar(): void {
    this._analyticsTag.trackCtaClick({
      ctaLabel: 'Finalizar',
      ctaSection: 'landing-aceptacion',
      ctaComponent: 'aceptacion-solicitud-credito',
      ctaElementId: 'btn-ofertas-landing-finalizar',
      hu: '8209',
    });
  }
}
